
<template>
  <div>

    <el-switch
        v-model="value1"
        inactive-text="是否按照文件名称排序"
        @change="getFileSwitch">
    </el-switch>

              <div style="height: 100%;width: 100%; ">

                <div style="width: 100%; height: 1px; border-bottom: 1px solid #ebeef5;  margin-top: 6px;"></div>

                <div style="overflow-y: auto;border-right: 1px solid #e7e4e4;padding-right: 13px; height: 80vh;">
                    <div>
                        <el-tree :data="dataTree" node-key="id"  :default-expanded-keys="expandedKeys"   :props="defaultProps" :allow-drop="allowDrop" :allow-drag="allowDrag"
                            @node-drop="handleDrop"
                            @node-drag-enter="handleDragEnter"
                            @node-click="handleClickTree"
                            @node-expand="handleNodeExpand"
                        >
                            <!--
                            @node-drag-start="handleDragStart"
                            @node-drag-enter="handleDragEnter"
                            @node-drag-leave="handleDragLeave"
                            @node-drag-over="handleDragOver"
                            @node-drag-end="handleDragEnd" -->

                            <span class="custom-tree-node box" slot-scope="{ node, data }">
                                <!-- <span style="flex:1">{{ node.label }}（{{ data.nmu ? data.nmu : 0 }}）</span> -->
                                <span style="flex:1">{{ node.label }}</span>
                                <span style="padding-right:10px">
                                    <el-popover stop-popper-mouse-event ref="popover" placement="right" width="80"  trigger="hover" style="position: absolute;right: 12px;"  v-if="data.isPopover">
                                        <div>
                                            <!-- <div style="margin-bottom: 10px;padding:10px;" class="add" @click="handleTreeClick('添加文件夹', node, data)">
                                                <span class="el-icon-folder-opened" style="margin-right: 3px; margin-left: 7px;"></span>
                                                <span>添加文件夹</span>
                                            </div> -->
                                            <div style="margin-bottom: 10px;padding:10px;" class="add" @click="handleTreeClick('添加子文件夹', node, data)">
                                                <span class="el-icon-folder-add" style="margin-right: 3px; margin-left: 7px;"></span>
                                                <span>添加子文件夹</span>
                                            </div>
                                            <div style="margin-bottom: 10px;padding:10px;" class="add" @click="handleTreeClick('修改文件夹', node, data)">
                                                <span class="el-icon-edit" style="margin-right: 3px; margin-left: 7px;"></span>
                                                <span>修改文件夹</span>
                                            </div>
                                            <div class="add" style="margin-bottom: 10px;padding:10px;" @click="handleTreeClick('上传资料', node, data)">
                                                <span class="el-icon-upload2" style="margin-right: 3px; margin-left: 7px;"></span>
                                                <span>上传资料</span>
                                            </div>
                                            <div class="add" style="padding:10px;" @click="handleTreeClick('删除文件夹', node, data)" >
                                                <span class="el-icon-delete" style="margin-right: 3px; margin-left: 7px;"></span>
                                                <span>删除文件夹</span>
                                            </div>
                                        </div>
                                        <span slot="reference">...</span>
                                    </el-popover>
                                </span>
                            </span>

                        </el-tree>
                      </div>


                    <div v-if="dataTree.length < 0">
                        <el-empty description="暂无文件列表~"></el-empty>
                    </div>
                </div>
            </div>


          <Elupload v-if="isShowElupload" @handleEventElUpload="handleEventElUpload" :id="parentIds"></Elupload>

          <el-dialog  :title="dialogVisibleAddDepTitle" :visible.sync="dialogVisibleAddDep"  width="30%" :before-close="handleCloseAddDep">
              <el-divider></el-divider>
              <div style="display: flex;">
                  <div style="width: 90px;padding-top: 5px;">文件名称：</div>
                  <el-input style="width: 100%;" v-model="flieName" clearable></el-input>
              </div>
              <span slot="footer" class="dialog-footer">
                  <el-button size="small"  @click="handleCloseAddDep">取 消</el-button>
                  <el-button size="small"  type="primary" @click="handleCloseAddDepSub">确 定</el-button>
              </span>
          </el-dialog>


  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { getSubject,} from "@/api/firstClassApi";

import Elupload from "./Elupload.vue";

import { sbmCreateFolderAPI,delFolderAPI,updateFolderAPI } from "@/api/fileSpace.js";


export default {
  components: { Elupload  },
  props:{
    dataTree:{
          default:[],
          type: Array
    },

    expandedKeysList:{
          default:[],
          type: Array
    },

  },
  data(){
    return{
        isSort:null,
        brothId:'',
        value1:false,
        defaultProps:{ children: 'children', label: 'folderName' },
        isShowElupload: false,

        dialogVisibleAddDep: false,
        dialogVisibleAddDepTitle: '',

        flieName: '',
        parentIds:'',

        expandedKeys:[],
    }
  },
  mounted(){

    if(this.expandedKeysList && this.expandedKeysList.length > 0){
        this.expandedKeys = this.expandedKeysList
    }else{
      this.expandedKeys = [1]
    }

  },


  methods:{

    handleNodeExpand(node, expandedNodes) {
      let newsexpandedKeys = [node.id]
      this.expandedKeys = newsexpandedKeys
    },

    getFileSwitch(e){
        this.isSort = e
        if(e === true){
            this.$emit('handleEventGetListFile' ,this.brothId,1)
        }else{
            this.$emit('handleEventGetListFile' ,this.brothId,0)
        }
    },


    handleEventElUpload(type,tepyId){
        this.isShowElupload = false
        this.$emit('handleEventGetFileFolder',tepyId)
    },
    handleTreeClick(type, node, data){


        if(type === '添加文件夹'){
            this.dialogVisibleAddDepTitle = '添加文件夹'
            this.dialogVisibleAddDep = true
            if(data.folderId !== ''){
            this.parentIds = data.folderId
            }else{
            his.parentIds = ''
            }

        }

        if(type === '添加子文件夹'){
            this.dialogVisibleAddDepTitle = '添加子文件夹'
            this.dialogVisibleAddDep = true
            this.parentIds = data.folderId

        }

        if(type === '修改文件夹'){
            this.flieName = data.folderName
            this.parentIds = data.id
            this.dialogVisibleAddDepTitle = '修改文件夹'
            this.dialogVisibleAddDep = true
        }

        if(type === '上传资料'){
            this.isShowElupload = true
            this.parentIds = data.folderId
        }

        if(type === '删除文件夹'){
            this.$confirm('此操作将删除文件夹， 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                // this.handleDelete(data.id)
                delFolderAPI(data.id).then(res=>{
                    if(res.code === 200){
                        // this.getFileFolder()

                        this.$emit('handleEventGetFileFolder')

                        this.$message({ type: 'success', message: res.message })
                    }else{
                        this.$message({ type: 'error', message: res.message })
                    }
                })
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' })
            })
        }

    },

    handleCloseAddDep() {
      this.flieName = ''
      this.parentIds = ''
      this.dialogVisibleAddDepTitle = ''
      this.dialogVisibleAddDep = false
    },


    handleCloseAddDepSub() {

      if(this.dialogVisibleAddDepTitle === '添加文件夹'){
        let data ={
            folderName:this.flieName,
            parentId:this.parentIds
        }
        sbmCreateFolderAPI(data).then(res=>{
            if(res.code === 200){
                this.flieName = ''
                this.parentIds = ''
                this.dialogVisibleAddDep = false
                this.$emit('handleEventGetFileFolder')
                this.$emit('handleEventKeys', this.expandedKeys)
                this.$message({ type: 'success', message: res.message })
            }else{
                this.flieName = ''
                this.parentIds = ''
                this.$message({ type: 'error', message: res.message })
            }
        })

      }

      if(this.dialogVisibleAddDepTitle === '添加子文件夹'){
        let data ={
            folderName:this.flieName,
            parentId:this.parentIds
        }
        sbmCreateFolderAPI(data).then(res=>{
            if(res.code === 200){
                this.flieName = ''
                this.parentIds = ''
                this.dialogVisibleAddDep = false
                this.$emit('handleEventGetFileFolder')
                this.$message({ type: 'success', message: res.message })
            }else{
                this.flieName = ''
                this.parentIds = ''
                this.$message({ type: 'error', message: res.message })
            }
        })

      }


      if(this.dialogVisibleAddDepTitle === '修改文件夹'){
        let data ={
            folderName:this.flieName,
            id:this.parentIds
        }
        updateFolderAPI(data).then(res=>{
            if(res.code == 200){
                this.flieName = ''
                this.parentIds = ''
                // this.getFileFolder()
                this.$emit('handleEventGetFileFolder')
                this.dialogVisibleAddDep = false
                this.$emit('handleEventGetFileFolder')
                this.$message({ type: 'success', message: res.message })
            }else{
                this.flieName = ''
                this.parentIds = ''
                this.$message({ type: 'error', message: res.message })
            }
        })

      }

    },

    allowDrop(draggingNode, dropNode, type) {
        return dropNode.data.deptName !== '蒙正课堂';
    },

    allowDrag(draggingNode) {
        return draggingNode.data.deptName !== '蒙正课堂';
    },

    handleDrop(draggingNode, dropNode, dropType, ev) {
        let { parent, data } = draggingNode
        this.SonNodeID = data.deptId
        this.handleMove()
    },

    handleClickTree(data){
        // 

        this.brothId = data.folderId
        this.$EventBus.$emit('handleBrotherEevet',data)

        if(this.isSort === true){
            this.$emit('handleEventGetListFile' ,data.folderId, 1)
        }else{
            this.$emit('handleEventGetListFile' ,data.folderId,0)
        }

        this.isDisplay = data.isDisplay == 1 ? true : false
        this.isID = data.deptId
        this.isIDS = data.id
        this.ShowResignationView = false
    },

    handleDragEnter(draggingNode, dropNode, ev) {
        let { data } = dropNode
        this.ParentLevelD = data.deptId
    },

  }
}

</script>


<style lang="less" scoped>

    .btn{
        background-color: #1890ff;
        border-color: #1890ff;
    }

    /deep/ .el-card__body{
          padding: 0px;
    }

    /deep/ .el-input__inner{
        height: 30px;
    }

    /deep/ .el-input__prefix{
        margin-top: -5px;
    }


    /deep/ .el-tree-node.is-current > .el-tree-node__content{
        color: #1890ff;
        background: #e8f4ff;
    }

    .add:hover{
        padding: 10px 10px;
        background: #4992df;
        color: #fff;
        border-radius: 5px;
    }

    /deep/ .el-drawer__header{
        font-weight: 900;
        font-size: 18px;
        background: #f5f7fa;
        padding: 15px 20px;
    }

    /deep/.el-divider--horizontal{
        margin-top: -26px;
    }

    /deep/ .el-dialog__header{
        text-align: start;
    }

    /deep/ .el-drawer__header{
        text-align: start;
    }

    /deep/ .el-input__suffix-inner{
        display: flex;
        margin-top: -3px;
    }

    /deep/ .el-range__close-icon{
        position: absolute;
        right: 0px;
    }
    /deep/ .el-range-separator{
        margin-top: -10px;
    }

    /deep/ .el-icon-date{
        display: none;
    }
    .no_click {
        pointer-events: none;
    }



</style>
























// WEBPACK FOOTER //
// src/FileSpace/treeCompoents.vue